import { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { addPaymentMethod } from '../../../../api/services/paymentService';

const ModalOverlay = styled.div`
  display: flex;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.h2`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #1d1e7d;
  border-bottom: 1px solid #ccc;
  padding-bottom: 0.5rem;
`;

const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  & > * {
    flex: 1;
  }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Input = styled.input`
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
`;

const Select = styled.select`
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
`;

const Label = styled.label`
  font-size: 0.75rem;
  font-weight: bold;
  color: #1d1e7d;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid black;
  cursor: pointer;

  &.primary {
    background-color: black;
    color: white;
  }

  &.secondary {
    background-color: white;
    color: black;
  }
`;

export default function AddPaymentMethodModal({
  title = 'ADD A CREDIT CARD',
  show,
  refresh,
  onClose,
}) {
  if (!show) return null;
  const userInfo = useSelector((state) => state.userInfo);

  const [form, setForm] = useState({
    cardNumber: '',
    firstName: '',
    lastName: '',
    expMonth: '',
    expYear: '',
    cvv: '',
    isCash: false,
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleAddPayment = async () => {
    const result = await addPaymentMethod(userInfo.idCustomer, {
      newIdCC: null,
      CCNumber: form.cardNumber,
      CNAMEF: form.firstName,
      CNAMEL: form.lastName,
      CCExpYear: form.expYear,
      CCExpMonth: form.expMonth,
    });
    if (result.payment_method.isAdded) {
      refresh();
    }
    onClose();
  };

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>{title}</ModalHeader>

        <FormGrid>
          <Column>
            <Label>EXPIRATION DATE</Label>
            <Row>
              <Select
                value={form.expMonth}
                onChange={(e) => handleChange('expMonth', e.target.value)}
              >
                <option value=''>Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1}>{String(i + 1).padStart(2, '0')}</option>
                ))}
              </Select>
              <Select
                value={form.expYear}
                onChange={(e) => handleChange('expYear', e.target.value)}
              >
                <option value=''>Year</option>
                {Array.from({ length: 10 }, (_, i) => {
                  const y = new Date().getFullYear() + i;
                  return <option key={y}>{y}</option>;
                })}
              </Select>
            </Row>
          </Column>
          <Column>
            <Label>CARD NUMBER</Label>
            <Input
              placeholder='Card Number'
              value={form.cardNumber}
              onChange={(e) => handleChange('cardNumber', e.target.value)}
            />
          </Column>
          <Row>
            <Column>
              <Label>FIRST NAME</Label>
              <Input
                placeholder='First Name'
                value={form.firstName}
                onChange={(e) => handleChange('firstName', e.target.value)}
              />
            </Column>
            <Column>
              <Label>LAST NAME</Label>
              <Input
                placeholder='Last Name'
                value={form.lastName}
                onChange={(e) => handleChange('lastName', e.target.value)}
              />
            </Column>
          </Row>

          <Column>
            <Label>CVV</Label>
            <Input
              placeholder='CVV'
              value={form.cvv}
              onChange={(e) => handleChange('cvv', e.target.value)}
            />
          </Column>

          <ButtonRow>
            <Button className='secondary' onClick={onClose}>
              Cancel
            </Button>
            <Button className='primary' onClick={handleAddPayment}>
              Add your card
            </Button>
          </ButtonRow>
        </FormGrid>
      </ModalContainer>
    </ModalOverlay>
  );
}
